import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";

import moment from "moment";
import {
  detectTipoPessoa,
  normalizeDocumentoInput
} from "@/helpers/documento-identificacao.helper";

export class ReportAPI extends BaseAPI<any> {
  constructor() {
    super();
  }

  public relatorioFrotaVeiculo(
    tipo: number,
    cnpj: string,
    // token: string,
    recaptcha: string,
    placa: string,
    numOrdem: number
  ): AxiosObservable<any> {
    const urlRelatorioRegular = `${this.apiUrl}/api/pdf/sit/relatorio-frota/veiculos/regular`;
    const urlRelatorioComplementar = `${this.apiUrl}/api/pdf/sit/relatorio-frota/veiculos/complementar`;
    const apiUrl = tipo === 1 ? urlRelatorioRegular : urlRelatorioComplementar;

    if (placa) placa = placa.replace("-", "");

    return this.axios.post(
      `${apiUrl}`,
      {
        cnpj,
        // token,
        recaptcha,
        placa,
        numOrdem
      },
      { responseType: "blob" }
    );
  }

  public relatorioFrotaAutoInfracao(
    tipo: number,
    cnpj: string,
    recaptcha: string,
    placa: string,
    dataInicio: string,
    dataFim: string,
    numOrdem: number

  ): AxiosObservable<any> {
    const urlRelatorioRegular = `${this.apiUrl}/api/pdf/sit/relatorio-frota/auto-infracao/regular`;
    const urlRelatorioComplementar = `${this.apiUrl}/api/pdf/sit/relatorio-frota/auto-infracao/complementar`;
    const apiUrl = tipo === 1 ? urlRelatorioRegular : urlRelatorioComplementar;

    if (placa) placa = placa.replace("-", "");

    if (dataInicio)
      dataInicio = moment(dataInicio, "DD/MM/YYYY").format("YYYY-MM-DD");

    if (dataFim) dataFim = moment(dataFim, "DD/MM/YYYY").format("YYYY-MM-DD");

    return this.axios.post(
      `${apiUrl}`,
      {
        cnpj,
        recaptcha,
        placa,
        dataInicio,
        dataFim,
        numOrdem
      },
      { responseType: "blob" }
    );
  }

  public certificadoInclusaoVeiculo(
    cnpj: string,
    placa: string,
    recaptcha: string,    
    numOrdem: number
  ): AxiosObservable<any> {
    const apiUrl = `${this.apiUrl}/api/sit/certificado/certidao-inclusao`;    

    if (placa) placa = placa.replace("-", "");

    return this.axios.post(
      `${apiUrl}`,
      {      
        cnpj,  
        placa,    
        recaptcha,
        numOrdem
      },
      { responseType: "blob" }
    );
  }

  public certificadoRegistro(
    cnpj: string,
    recaptcha: string,    
    numOrdem: number

  ): AxiosObservable<any> {
    const apiUrl = `${this.apiUrl}/api/sit/certificado/certificado-registro`;    

    if (cnpj) cnpj = normalizeDocumentoInput(cnpj, detectTipoPessoa(cnpj));

    return this.axios.post(
      `${apiUrl}`,
      {      
        cnpj,  
        recaptcha,
        numOrdem
      },
      { responseType: "blob" }
    );
  }
}
